/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NewsCreateNewsRequest } from "../models/NewsCreateNewsRequest";
import type { NewsCreateNewsResponseApiRespoonse } from "../models/NewsCreateNewsResponseApiRespoonse";
import type { NewsDeleteNewsRequest } from "../models/NewsDeleteNewsRequest";
import type { NewsDeleteNewsResponseApiRespoonse } from "../models/NewsDeleteNewsResponseApiRespoonse";
import type { NewsEditNewsRequest } from "../models/NewsEditNewsRequest";
import type { NewsEditNewsResponseApiRespoonse } from "../models/NewsEditNewsResponseApiRespoonse";
import type { NewsListNewsRequest } from "../models/NewsListNewsRequest";
import type { NewsListNewsResponseApiRespoonse } from "../models/NewsListNewsResponseApiRespoonse";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class NewsManagerService {
  /**
   * Get list news
   * @param requestBody
   * @returns NewsListNewsResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static news(
    requestBody: NewsListNewsRequest
  ): CancelablePromise<NewsListNewsResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/news",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Create news
   * @param requestBody
   * @returns NewsCreateNewsResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static newsCreate(
    requestBody: NewsCreateNewsRequest
  ): CancelablePromise<NewsCreateNewsResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/news/create",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Update news
   * @param requestBody
   * @returns NewsEditNewsResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static newsEdit(
    requestBody: NewsEditNewsRequest
  ): CancelablePromise<NewsEditNewsResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/news/edit",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Delete news
   * @param requestBody
   * @returns NewsDeleteNewsResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static newsDelete(
    requestBody: NewsDeleteNewsRequest
  ): CancelablePromise<NewsDeleteNewsResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/news/delete",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }
}
